var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.727,
    height: 143,
    viewBox: "0 0 128.727 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1279"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-hexagon",
    d: "M128.726 100.106V42.897a14.3 14.3 0 0 0-7.151-12.372L71.515 1.916a14.3 14.3 0 0 0-14.3 0L7.151 30.522A14.3 14.3 0 0 0 0 42.897v57.212a14.3 14.3 0 0 0 7.151 12.372l50.06 28.606a14.3 14.3 0 0 0 14.3 0l50.06-28.606a14.3 14.3 0 0 0 7.155-12.375Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1272"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-people",
    d: "M81.372 66.808a14.077 14.077 0 1 0-14.077-14.077 14.018 14.018 0 0 0 14.077 14.077Zm0 9.385c-1.361 0-2.909.094-4.552.235 5.443 3.942 9.244 9.244 9.244 16.188v11.73h28.154v-11.73c0-10.933-21.913-16.423-32.846-16.423Z",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-people",
    d: "M47.353 66.808a14.077 14.077 0 1 0-14.077-14.077 14.018 14.018 0 0 0 14.077 14.077Zm0 9.385c-10.933 0-32.846 5.49-32.846 16.423v11.73H80.2v-11.73c0-10.933-21.913-16.423-32.847-16.423Z",
    fill: "#39beec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDao);
export default __webpack_public_path__ + "static/media/Dao.b61b2cd3cba3a8898fc86a474296fd9b.svg";
export { ForwardRef as ReactComponent };